import heading from "./HeadingRenderer";
import link from "./LinkRenderer";
import listItem from "./ListItemRenderer";
import paragraph from "./ParagraphRenderer";
import table from "./TableRenderer";
export default {
    heading: heading,
    link: link,
    listItem: listItem,
    paragraph: paragraph,
    table: table,
};
//# sourceMappingURL=index.js.map